import { ActionType, AuditLogField } from '@zen/graphql/types.generated';

import type { AuditLogsQueryResult } from '../graphql';

export { AuditLogField };

export { ActionType };
export interface AuditLogsFilters {
  actorId?: string[];
  entityId?: string[];
  entityType?: string[];
  field?: AuditLogField[];
  parentEntityId?: string[];
  parentEntityType?: string[];
  source?: string[];
}

export type AuditLogNode = NonNullable<NonNullable<AuditLogsQueryResult['auditLogs']>['nodes']>[number];

export const ACTION_TYPE_LABELS: Record<ActionType, string> = {
  [ActionType.CHANGED]: 'Changed',
  [ActionType.ENTERED]: 'Entered',
  [ActionType.REMOVED]: 'Removed'
};

export type GroupedEntry = [string, AuditLogNode[]];
